const en = {
  //COMMON
  nameRequired: "Name is required.",
  firstNameRequired: "First Name is required.",
  lastNameRequired: "Last Name is required.",
  emailRequired: "Email is required.",
  phoneRequired: "Phone Number is required.",
  genderRequired: "Gender is required.",
  dobRequired: "Date of Birth is required.",
  firstNamelength: "First name must be at least 3 characters.",

  experienceRequired: "Experience is required.",
  suggestionRequired: "Suggestion is required.",
  onlyAlphabetsAllowed: "Only alphabets and spaces are allowed.",

  //PROFILE
  pincodeRequired: "Valid 6-digit Pincode is required.",
  stateRequired: "State is required.",
  districtRequired: "District is required.",
  cityRequired: "City/Town/Village is required.",
  addressRequired: "Address is required.",
  religionRequired: "Religion is required.",
  templeFrequencyRequired: "Temple Visit Frequency is required.",
  languageRequired: "Language is required.",
  phoneTenDigits: "The phone number must be 10 digits.",
  phonestarts: "Number cannot start from 0.",
  aadharInvalid: "Aadhar number must be a 12-digit number.",
  passportInvalid:
    "Passport number must be 1 letter followed by 7 digits (e.g., K1234567).",
  firstNameInvalid: "First name must only contain letters and spaces.",
  lastNameInvalid: "Last name must only contain letters and spaces.",

  //PASSWORD
  currentPasswordRequired: "Current password is required.",
  newPasswordRequired: "New password is required.",
  confirmPasswordRequired: "Confirm password is required.",
  currentPasswordInvalid:
    "Current password must be at least 8 characters and include one uppercase letter, one lowercase letter, one number, and one special character.",
  newPasswordInvalid:
    "New password must be at least 8 characters and include one uppercase letter, one lowercase letter, one number, and one special character.",
  confirmPasswordInvalid:
    "Confirm password must be at least 8 characters and include one uppercase letter, one lowercase letter, one number, and one special character.",
  passwordsNotMatch: "New password and confirm password must match.",
  emojiNotAllowed: "Emojis are not allowed in password.",
  incorrectCurrentPassword: "The current password you entered is incorrect.",
  sameAsCurrentPassword:
    "The new password cannot be the same as the current password.",

  //IMAGE
  fileTooLarge: "File size must not exceed 2MB.",
  invalidFileType: "Invalid file type. Please upload a JPG/JPEG or PNG image.",
  imageUploadFailed: "Image upload failed. Please try again.",
};

export default en;
